<ng-container *transloco="let t">
  <section
    class="best-category-deals-picker-component"
    [class.widescreen]="(biggerThan$ | async)?.mobileL"
    [class.largescreen]="(biggerThan$ | async)?.sm">
    <div class="flex justify-between full-width align-base">
      <h3>
        {{ (language$ | async) === 'ar' ? ' أفضل العروض على ' : 'Best deals on' }}
        {{
          t('category_' + (capitalizeCategory(category)?.toLowerCase() || '') + '_title')
        }}
      </h3>
    </div>

    <span class="fixed-space-8" aria-hidden="true"></span>

    <div class="cards">
      <div class="card products flex flex-col">
        <app-product-brand-selector
          [onlyBestPhoneBrands]="category === 'SMARTPHONE' || category === 'TABLET'"
          [onlyBestLaptopBrands]="category === 'LAPTOP'"
          [smallMode]="true"
          [phoneFilterOptions]="{ brands: [filteredBrand() || ''] }"
          (filterBrandChanged)="switchBrand($event)" />
        <span class="fixed-space-8" aria-hidden="true"></span>

        <nav class="filters">
          @for (filter of productCategories(); let index = $index; track trackByKey) {
            <span
              class="badge"
              [class.selected]="
                index !== 3
                  ? filteredMaxPrice() === filter.price.amount
                  : filteredMinPrice() === filter.price.amount
              "
              (click)="switchPrice(filter.price.amount, index === 3)">
              @if (index !== 3) {
                <span>
                  {{ (language$ | async) === 'ar' ? 'أقل من ' : 'Under' }}
                  {{ filter.price | amount }}
                </span>
              } @else {
                <span>
                  {{ (language$ | async) === 'ar' ? 'أكثر من ' : 'Above' }}
                  {{ filter.price | amount }}
                </span>
              }
            </span>
          }
        </nav>

        @if (bestSellersPerCategory()?.length) {
          <app-popsy-scroller>
            @for (best of bestSellersPerCategory(); track trackByKey) {
              <app-cheapest-seller-card [product]="best" />
            }
          </app-popsy-scroller>
        } @else {
          <span class="fixed-space-32" aria-hidden="true"></span>
          @if ((language$ | async) === 'ar') {
            <div class="flex justify-center align-center">
              عذرًا، لا توجد منتجات لعرضها
            </div>
          } @else {
            <div class="flex justify-center align-center">Sorry, no products to show</div>
          }
        }
      </div>
    </div>

    <span class="fixed-space-32" aria-hidden="true"></span>

    <a
      [routerLink]="urlFragments"
      [queryParams]="queryParameters"
      class="button popsy-button-primary cta badge blue-button margin-0-auto">
      @if ((language$ | async) === 'ar') {
        {{ 'عرض المزيد' }}
      } @else {
        See more
      }
      {{
        t('category_' + (capitalizeCategory(category)?.toLowerCase() || '') + '_title')
      }}
    </a>
  </section>
</ng-container>
